import * as React from 'react';

type ProjectLeftPanelTitleProps = {
    title: string | JSX.Element,
    addBtn?: React.ReactChild
    collapsed?: boolean
    onCollapsedClick?: () => void;
}

function ProjectLeftPanelTitle({ title, addBtn, collapsed, onCollapsedClick }: ProjectLeftPanelTitleProps) {
    
    return (
        <div className="ProjectLeftPanel__title">
            {collapsed !== undefined && <i className="icon icon-alan-chevron-fat arrow-rect" onClick={onCollapsedClick} />}
            {title}
            {addBtn}
        </div>
    );
}

export default ProjectLeftPanelTitle;
